import { TrackEvents } from "@/components/nw-track/events";
import { AuthEvents } from "@/components/nw-auth-manager";

export class ScrollService {
  static STORAGE_KEY = "scroll_pos";

  startObservation() {
    addEventListener(AuthEvents.LoginClicked, this.saveScrollPosition);
    addEventListener(TrackEvents.TRACK_LOADED, this.restoreScrollPosition);
  }

  saveScrollPosition(): void {
    const scrollY = window.scrollY;
    sessionStorage.setItem(ScrollService.STORAGE_KEY, scrollY.toString());
  }

  restoreScrollPosition(): void {
    const scrollYStr = sessionStorage.getItem(ScrollService.STORAGE_KEY);
    if (scrollYStr == null) {
      return;
    }

    window.scroll({ top: parseFloat(scrollYStr) });
    sessionStorage.removeItem(ScrollService.STORAGE_KEY);
  }
}
